/* eslint-disable default-case */
/* eslint-disable import/no-anonymous-default-export */
import{
    GET_WATCH,
    GET_WATCH_SUCCESS,
    GET_WATCH_FAIL,
    GET_WATCH_RESET
} from '../action/getWatchAction'

import{ api_err_msg} from '../strings.json'

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}
export default function(state = initialState, action){
    switch(action.type){
        case GET_WATCH :
            return{ 
                ...state,
                apiState: 'loading'
            }
        case GET_WATCH_FAIL : 
            return{ 
                ...state,
                apiState: 'error',
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_WATCH_SUCCESS : 
            return{ 
                ...state,
                apiState: 'success',
                data:action.response.data.data.result.video,
            }
        case GET_WATCH_RESET:
            return initialState
        default:
            return state
    }
}